export default {
  sections: {
    address: 'Geschäftsadresse',
    address_help: 'Gib die Adresse ein, unter der dein Unternehmen registriert ist. Sie steht auf deinen Rechnungen.',
  },
  form: {
    legal_form: {
      label: 'Rechtsform',
      help: 'Eine UG (haftungsbeschränkt) wählt hier GmbH, ein e.K. Einzelunternehmen. Für eine OHG oder KG wende dich bitte an den Support.',
      options: {
        sole_trader: 'Einzelunternehmen',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Eingetragener Firmenname',
      placeholder: 'Eingetragenen Firmennamen eingeben',
      sole_trader_help: 'Leer lassen, wenn du unter deinem eigenen Namen handelst',
    },
  },
  buttons: {
    next: 'Weiter',
  },
};
